import { FileFormats } from "../../../../components/FinalForms/libs/data/fileFormatTypes";
import { validationTypes } from "../../../../components/FinalForms/libs/data/ValidationTypes";
import { FormFieldTypes } from "../../../../data/formFieldType";

const initState = {
  firstName: "",
  lastName: "",
  contactEmail: "",
  contactPhone: "",
  positionApplied: null,
  responsibleUser: null,
  candidateResume: "",
  skillId: "",
  applyDate: "",
};

const addCandidateFields = {
  name: "Add Candidate",
  initialState: initState,
  section: [
    {
      title: "Profile Section",
      row: {},
      style: {
        sectionStyle: "row",
      },
      fields: [
        {
          id: "FirstName",
          label: "First Name",
          Field_Name: "First Name",
          fieldType: FormFieldTypes.INPUT,
          dataField: "firstName",
          fieldSetting: {
            placeholder: "Please Enter First Name",
            // isReadOnly:true,
            //isDisable:true
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-md-6",
          },
        },
        {
          id: "lastName",
          label: "Last Name",
          Field_Name: "Last Name",
          fieldType: FormFieldTypes.INPUT,
          dataField: "lastName",
          fieldSetting: {
            placeholder: "Please Enter Last Name",
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-md-6",
          },
        },
        {
          id: "emailAddress",
          label: "Email Address",
          Field_Name: "Email Address",
          fieldType: FormFieldTypes.INPUT,
          dataField: "contactEmail",
          fieldSetting: {
            placeholder: "Please Enter Email Address",
          },
           validation: [{ type: validationTypes.REQUIRE }, {type: validationTypes.EMAIL } ],
          style: {
            containerCss: "col-md-6",
          },
        },

        {
          id: "Phone Number",
          label: "Phone Number",
          Field_Name: "Phone Number",
          fieldType: FormFieldTypes.INPUT,
          dataField: "contactPhone",
          fieldSetting: {
            placeholder: "Please Enter Phone Number",
            maskFormat: "#####-#####",
            //   maskFormat: "+91 (###) #### ###",
            //   extendedFormat: "(###) ###-#### ",
            //   minValueLength: 1,
            //   pattern:  /^((\+91?)|\+)?[7-9][0-9]{12}$/,
            allowSpace: true,
          },
          validation: [
            { type: validationTypes.REQUIRE },
            { type: validationTypes.PHONENUMBER },
          ],

          style: {
            containerCss: "col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-12",
          },
        },
        {
          id: "jobPositions",
          label: "Position",
          Field_Name: "Job Position",
          fieldType: FormFieldTypes.SELECT,
          dataField: "positionApplied",
          fieldSetting: {
            placeholder: "Please Select Positions",
            options: [],
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-md-6",
          },
        },
        // {
        //   id: "skillId",
        //   label: "Skill",
        //   Field_Name: "Skill",
        //   fieldType: FormFieldTypes.SELECT,
        //   dataField: "skillId",
        //   fieldSetting: {
        //     placeholder: "Please Select Skill",
        //     isMultiSelect: true,
        //     options: [],
        //   },
        //   // validation: [{ type: "require" }],
        //   style: {
        //     containerCss: "col-md-6",
        //   },
        // },
        {
          id: "responsibleUser",
          label: "Human Resource",
          Field_Name: "Human Resources",
          fieldType: FormFieldTypes.SELECT,
          dataField: "responsibleUser",
          fieldSetting: {
            placeholder: "Please Select Human resource",
            options: [],
          },
          // validation: [{ type: "require" }],
          style: {
            containerCss: "col-md-6",
          },
        },
        {
          id: "applyDate",
          label: "Apply Date",
          Field_Name: "Apply Date",
          fieldType: FormFieldTypes.DATEPICKER,
          dataField: "applyDate",
          fieldSetting: {
            placeholder: "Apply Date",
            options: [],
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-md-6",
          },
        },
        {
          id: "candidateResume",
          label: "Candidate Resume",
          Field_Name: "Candidate Resume",
          fieldType: FormFieldTypes.FILE,
          dataField: "candidateResume",
          fieldSetting: {
            placeholder: "Upload Attachment",
            // allowSpace: true,
            // isShowPreview: false,
            allowMultipleFiles: false,
            // isButtonVisible: false,
            // isCustomButtonVisible: true,
            acceptedFileFormats: [
              FileFormats.PDF,
              //  FileFormats.DOCX
            ],
            // minFileSizeInMB: 1, // Minimum File size in MB
            // maxFileSizeInMB: 4, // Maximum File size in MB
          },
          // validation: [{ type: "require" }],
          style: {
            containerCss: "col-md-10",
          },
        },
      ],
    },
  ],
  formSetting: {
    isViewOnly: false,
}
};

export default addCandidateFields;
